import clsx from 'clsx'
import {FC} from 'react'
import {toAbsoluteUrl} from '../../../helpers'
import {HeaderUserMenu, ThemeModeSwitcher} from '../../../partials'
import {useLayout} from '../../core'
import { useAuth } from '../../../../app/modules/auth'
import NotificationBell from '../../../../app/components/NotificationBell'

const itemClass = 'ms-1 ms-lg-3',
  btnClass = 'btn btn-icon btn-active-light-primary w-30px h-30px w-md-40px h-md-40px',
  userAvatarClass = 'symbol-30px symbol-md-40px'

const Topbar: FC = () => {
  const {config} = useLayout()
  const today = new Date()
  const {currentUser} = useAuth()
  const userId = currentUser?.id || '';  //Notification

  const getGreeting = () => {
  const hour = new Date().getHours()

    if (hour < 12) return 'Good Morning'
    if (hour < 18) return 'Good Afternoon'
    return 'Good Evening'
  }

  return (
    <div className='d-flex align-items-stretch ms-auto flex-shrink-0'>
      {/* begin::Theme mode */}
      {/* <div className={clsx('d-flex align-items-center', itemClass)}>
        begin::Menu- wrapper
        <div
          className={clsx(btnClass, 'position-relative')}
          data-kt-menu-trigger='click'
          data-kt-menu-attach='parent'
          data-kt-menu-placement='bottom-end'
        >
          <i className='bi bi-bell fs-2' />
        </div>
        <HeaderNotificationsMenu />
        end::Menu wrapper
      </div> */}

      {/* Greating + User Name */}
      <div className='d-flex align-items-center flex-wrap'>
        <div className='d-flex align-items-center'>
          {/* <div className='btn btn-sm btn-bg-light btn-color-gray-500 btn-active-color-primary me-2'>
            <span className='fw-bolder'>
              {today.toLocaleString('default', {weekday: 'long'})} {today.getDate()}{' '}
              {today.toLocaleString('default', {month: 'long'})}
            </span>
          </div> */}
          <div className='btn btn-sm btn-bg-light btn-color-gray-500 btn-active-color-primary me-2'>
            <div className='fw-bolder'>
              {getGreeting()}, {currentUser?.firstName} {currentUser?.lastName}
            </div>

            <div style={{fontSize: '11px', color: '#888'}}>
              {today.toLocaleString('default', {weekday: 'long'})} {today.getDate()}{' '}
              {today.toLocaleString('default', {month: 'long'})}
            </div>
          </div>
          {/* {isOrganization && (
                <div className='d-flex align-items-center'>
                  <ProjectToolbar />
                </div>
              )} */}
        </div>
      </div>

      {/* Notification Bell */}
      <div className={clsx('d-flex align-items-center', itemClass)}>
        <NotificationBell userId={userId} />
      </div>

      {/* Theme */}
      <div className={clsx('d-flex align-items-center', itemClass)}>
        <ThemeModeSwitcher toggleBtnClass={btnClass} />
      </div>
      {/* end::Theme mode */}

      {/* begin::User */}
      <div className={clsx('d-flex align-items-center', itemClass)} id='kt_header_user_menu_toggle'>
        {/* begin::Toggle */}
        <div
          className={clsx('cursor-pointer symbol', userAvatarClass)}
          data-kt-menu-trigger='click'
          data-kt-menu-attach='parent'
          data-kt-menu-placement='bottom-end'
        >
          <img src={toAbsoluteUrl('/media/avatars/blank.png')} alt='user profile' />
        </div>
        <HeaderUserMenu />
        {/* end::Toggle */}
      </div>
      {/* end::User */}

      {/* begin::Aside Toggler */}
      {/* {config.header.left === 'menu' && (
        <div className='d-flex align-items-center d-lg-none ms-2' title='Show header menu'>
          <div
            className='btn btn-icon btn-active-color-primary w-30px h-30px w-md-40px h-md-40px'
            id='kt_header_menu_mobile_toggle'
          >
            <i className='fa-solid fa-bars-staggered fs-1'></i>
          </div>
        </div>
      )} */}
    </div>
  )
}

export {Topbar}
